<template slot-scope="scope">
  <!-- 店铺管理 - 账单明细 - 支出 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="订单ID" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orderNumber }}
          </template>
        </el-table-column>
        <el-table-column label="购买服务名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              Math.sign(scope.row.consumption) == 1
                ? "+" + scope.row.consumption
                : scope.row.consumption
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="服务价格(元)"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- 判断正负数 -->
            {{
              Math.sign(scope.row.traceCoin) == 1
                ? "+" + scope.row.traceCoin
                : scope.row.traceCoin
            }}
          </template>
        </el-table-column>
        <el-table-column label="服务数量" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.typeName }}
          </template>
        </el-table-column>
        <el-table-column label="服务商" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        
        <el-table-column label="订单状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        <el-table-column label="结算状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        <el-table-column label="金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {},
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(9) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
